import { apiClient } from "@/lib/api-client";
import type { IkuMultiplierMap } from "./get-config-multipliers";

export const putConfigMultipliers = async (
  payload: IkuMultiplierMap,
): Promise<any> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const res = await apiClient(`${baseUrl}/api/v1/config/multipliers`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });
  return res;
};
